// src/analytics/usePageTracking.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import amplitude from './amplitude';

export default function usePageTracking() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    amplitude.track('Page View', { url: pathname + search });
  }, [pathname, search]);
}
